export const TEXT = {
  count: 'items left',
};
